<ng-container *ngIf="isTypeButton">
  <av-tooltip
    *ngIf="!isScreenShareLocal"
    message="Share your screen"
    [enabled]="!isScreenShareActive"
  >
    <button
      [attr.aria-label]="'Share screen or window' | translate"
      avButton
      ofType="icon"
      [size]="size"
      color="primary"
      class="room-control-min-size"
      id="btn-screen-share-start"
      (click)="toggleScreenShare()"
      [disabled]="isDisabled"
      [raised]="true"
      data-tid="display-capture/start"
    >
      <av-icon name="screen-out"></av-icon>
    </button>
  </av-tooltip>

  <av-tooltip *ngIf="isScreenShareLocal" message="Stop sharing">
    <button
      [attr.aria-label]="'Stop sharing screen or window' | translate"
      avButton
      ofType="icon"
      [size]="size"
      color="danger"
      class="room-control-min-size"
      id="btn-screen-share-stop"
      [disabled]="isOnHold"
      [class.pulse-danger]="!isOnHold"
      (click)="toggleScreenShare()"
      [raised]="true"
      data-tid="display-capture/stop"
    >
      <av-icon name="screen-stop"></av-icon>
    </button>
  </av-tooltip>
</ng-container>

<ng-container *ngIf="isTypeMenuItem">
  <av-menu-item
    icon="screen-out"
    *ngIf="!isScreenShareLocal"
    [arrow]="false"
    [disabled]="isDisabled"
    (select)="toggleScreenShare()"
  >
    {{ "Share your screen" | translate }}
  </av-menu-item>

  <av-menu-item
    icon="screen-stop"
    *ngIf="isScreenShareLocal"
    [disabled]="isOnHold"
    [arrow]="false"
    color="danger"
    (select)="toggleScreenShare()"
  >
    {{ "Stop sharing" | translate }}
  </av-menu-item>
</ng-container>
